import JSBI from "jsbi"

export { JSBI }

export function toBigInt(x: JSBI): bigint {
  return BigInt(x.toString())
}

export function toJSBI(x: bigint): JSBI {
  return JSBI.BigInt(x.toString())
}
